import { createStore, withProps } from '@ngneat/elf'
import { CollectionQuery } from '../gql/generated'
import { CollectionSlug } from '../enums/collection.enums'

const initialState = {
  collection: null as CollectionQuery['collection'] | null,
  error: null as string | null,
}

const createCollectionStore = (name: string) =>
  createStore({ name }, withProps<typeof initialState>(initialState))

export const homepageCarouselStore = createCollectionStore(
  CollectionSlug.HOMEPAGE_CAROUSEL
)
export const preOrdersStore = createCollectionStore(CollectionSlug.PRE_ORDERS)
export const bestSellerStore = createCollectionStore(CollectionSlug.BEST_SELLER)
export const flashDiscountStore = createCollectionStore(
  CollectionSlug.FLASH_DISCOUNT
)

export const homepageCarouselActions = {
  setCollection: (collection: CollectionQuery['collection'] | null) =>
    homepageCarouselStore.update((state) => ({ ...state, collection })),
  setError: (error: string | null) =>
    homepageCarouselStore.update((state) => ({ ...state, error })),
}

export const preOrdersActions = {
  setCollection: (collection: CollectionQuery['collection'] | null) =>
    preOrdersStore.update((state) => ({ ...state, collection })),
  setError: (error: string | null) =>
    preOrdersStore.update((state) => ({ ...state, error })),
}

export const bestSellerActions = {
  setCollection: (collection: CollectionQuery['collection'] | null) =>
    bestSellerStore.update((state) => ({ ...state, collection })),
  setError: (error: string | null) =>
    bestSellerStore.update((state) => ({ ...state, error })),
}

export const flashDiscountActions = {
  setCollection: (collection: CollectionQuery['collection'] | null) =>
    flashDiscountStore.update((state) => ({ ...state, collection })),
  setError: (error: string | null) =>
    flashDiscountStore.update((state) => ({ ...state, error })),
}
